import { ReactNode } from "react";

import { Select } from "@mui/material";
import { useField } from "formik";

import { Translate } from "@/components/Application/Translate";

interface Props
	extends React.DetailedHTMLProps<
		React.SelectHTMLAttributes<HTMLSelectElement>,
		HTMLSelectElement
	> {
	label: string;
	name: string;
	id: string;
	children: ReactNode;
	placeholder?: string;
	translationString?: string;
	style?: React.CSSProperties;
}

const CustomSelect = ({
	label,
	id,
	translationString,
	children,
	...props
}: Props) => {
	const [field, meta] = useField(props);

	const hasError = meta.touched && meta.error;

	return (
		<div className="mui-select">
			<label
				htmlFor={id}
				style={{ display: "block", marginBottom: "8px", color: "rgba(0, 0, 0, 0.6)" }}
			>
				<Translate String={translationString || ""}>{label}</Translate>
			</label>
			<Select
				id={id}
				{...field}
				{...props}
				error={hasError} // MUI's error prop
				native
				sx={{
					height: "40px",
					borderColor: hasError ? "error.main" : "inherit",
					"& .MuiOutlinedInput-notchedOutline": {
						borderColor: hasError ? "error.main" : "inherit",
					},
				}}
			>
				{children}
			</Select>
			{hasError && (
				<div style={{ color: "#d32f2f", fontSize: "0.875rem", marginTop: "4px" }}>
					{meta.error}
				</div>
			)}
		</div>
	);
};

export default CustomSelect;
